'use client';

import type { ReactElement } from 'react';
import dynamic from 'next/dynamic';

const Cards = dynamic(() => import('./components/cards'), { ssr: false });

export default function Allocations(): ReactElement {
  return (
    <div className="w-full flex items-center justify-center py-10">
      <div className="w-full flex p-3 sm:p-5 rounded-lg border flex-col items-center justify-center gap-10">
        <div className="w-full flex-1 flex flex-col gap-2.5">
          <p className="bg-linear-to-r from-emerald-500 via-cyan-500 to-blue-600 bg-clip-text text-transparent dark:from-emerald-300 dark:via-cyan-300 dark:to-blue-400 font-bold text-4xl">
            Allocations
          </p>
          <div className="w-full flex flex-col gap-1.5 font-light opacity-95 text-base">
            <p>All SOLAR allocations associated with your wallet will appear here.</p>
            <p>
              Connect the same wallet you used to send USDT to view your allocations, track the
              vesting schedule, and claim your unlocked SOLAR tokens.
            </p>
          </div>
        </div>
        <div className="w-full flex">
          <Cards />
        </div>
      </div>
    </div>
  );
}
